import * as React from "react";
import { NotFoundPage } from "@amzn/awsmp-max-ux-patterns/NotFoundPage";
import { usePageProps } from "./hooks/usePageProps";

export const NotFoundPageWrapper: React.FC = () => {
  const { logger } = usePageProps();

  return <NotFoundPage logger={logger} />;
};
